import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';

import { ClassNames } from '@/shared/classNames';

type TabsProperties = {
  children: ReactNode;
  onValueChange?: (value: string) => void;
  value: string;
};

type TabsTriggerProperties = {
  children: ReactNode;
  value: string;
};

export const Tabs = ({ children, onValueChange, value }: TabsProperties) => (
  <TabsPrimitive.Root className="grid min-w-0 gap-4" onValueChange={onValueChange} value={value}>
    {children}
  </TabsPrimitive.Root>
);

export const TabsList = ({ children }: { children: ReactNode }) => (
  <TabsPrimitive.List className="border-line bg-sidebar inline-flex w-fit rounded-lg border p-1">{children}</TabsPrimitive.List>
);

export const TabsTrigger = ({ children, value }: TabsTriggerProperties) => (
  <TabsPrimitive.Trigger
    className={ClassNames(
      'text-muted hover:text-ink min-h-9 rounded-md px-3 py-1.5 text-sm font-semibold transition-colors',
      'data-[state=active]:bg-raised data-[state=active]:text-ink data-[state=active]:shadow-sm',
    )}
    value={value}
  >
    {children}
  </TabsPrimitive.Trigger>
);

export const TabsContent = ({ children, value }: TabsTriggerProperties) => (
  <TabsPrimitive.Content className="min-w-0 rounded-md" value={value}>
    {children}
  </TabsPrimitive.Content>
);
